import React, { useEffect } from "react";
import "./styles/ProductPageFooter.css";
import {
  IonItem,
  IonLabel,
  IonButton,
  IonIcon,
  IonGrid,
  IonCol,
  IonRow,
  IonAvatar,
  IonImg,
  IonContent,
} from "@ionic/react";
import ImageArraySlider from "../UI/ImageArraySlider";
import {
  useAppDispatch,
  useAppSelector,
  useRecordUserInteractions,
  useSaveVcard,
  useStringToast,
  userActionsTable,
} from "../app/hooks";
import {
  call,
  callOutline,
  location,
  mail,
  mailOutline,
  phoneLandscapeOutline,
  logoFacebook,
  logoInstagram,
  logoLinkedin,
  logoYoutube,
  text,
  briefcaseOutline,
  phoneLandscape,
  locationOutline,
  appsOutline,
  bicycleOutline,
  callSharp,
  logoWhatsapp,
  copyOutline,
  download,
  returnDownForward,
  globeOutline,
  navigate,
  checkmarkCircle,
  ellipse,
  personOutline,
  pencil,
} from "ionicons/icons";
import { mobileWidthBreakpoint } from "../types/form_table_data_types";
import { getLogo, getValidWhatsAppPhone } from "../common/commonFunctions";
import { log } from "console";
import { createImmutableStateInvariantMiddleware } from "@reduxjs/toolkit";
import Card from "../UI/Card";
import { Clipboard } from "@capacitor/clipboard";
import { bhpEditLinks, getPageType, whatsappMessage } from "../types/constants";
import { BusinessDetailsType } from "../pages/BussinessHomePage";
import { isMobileNumber } from "../types/bhp_common_function";
import { useHistory } from "react-router";

const ProductPageFooter: React.FC<{
  verifyMode?: boolean;
  vCardPromo?: string;
  vcardMode?: boolean;
  name: string;
  website?: string;
  tagline: string;
  description: string;
  images: string[];
  openImageArray?: () => void;
  phones: string[];
  email: string;
  address: string;
  socialMedia?: {
    facebookLink?: string;
    instagramLink?: string;
    youtubeLink?: string;
    linkedinLink?: string;
  };
  vypzeeMode?: boolean;
  deliveryNotes?: string;
  companyName?: string;
  businessDetails: BusinessDetailsType;
  directionExec?: () => void;
  checkList?: {
    shopName: boolean;
    shopPhone: boolean;
    shopAddress: boolean;
    shopDealsIn: boolean;
  };
  updateChecklist?: (
    key: "shopName" | "shopPhone" | "shopAddress" | "shopDealsIn" | "shopQr",
    val: boolean
  ) => void;
}> = (props) => {
  // const images = props.images ? props.images : undefined;
  const widthObj = useAppSelector((state) => state.screenWidth);
  const saveVcard = useSaveVcard();
  const vypzeeAboutUs = [
    "VypZee is bringing your local markets with your trusted local shops online",
    "Explore and order from your local markets and shops from the comfort of your home",
    "Stay updated on offers and promotions from your local trusted shopkeepers and save big.",
  ];
  const vypzeePhone = ["84483 38565", "98187 83337"];
  const vypzeeMail = "info@idigizen.com";
  const vypzeeAddresss = "251 A , E Block, Sushant Lok, Gurugram, Haryana";

  // if (props.description) {
  //   console.log("discription in footer", props.description);
  // }
  const splittedDiscriptionArray = props.description?.split("@");
  const splittedDiscription = splittedDiscriptionArray
    ? splittedDiscriptionArray[0]
    : "";
  const afterText = splittedDiscriptionArray
    ? splittedDiscriptionArray[1]?.trim()
    : "";
  const hyperlink = afterText?.split("\n", 2);

  // Use JavaScript string methods to split the paragraph
  const words = afterText?.split(" "); // Split by space

  // Extract the first word and the rest of the text
  const firstWord = words ? words[0] : "";
  const restOfText = words?.slice(1).join(" ");
  const presentStringToast = useStringToast();

  // const textAfterEmailArray = afterText?.slice(1, hyperlink.length);
  // const hyperlinkString = hyperlink[1].toString();

  // useEffect(() => {
  //   const adjustWidth = () => {
  //     const divEl = document.getElementById(
  //       "product-footer-picture-id"
  //     ) as HTMLElement;
  //     if (divEl) {
  //       divEl.style.width = `${divEl.offsetHeight * 1.33}px`;
  //     }
  //   };
  //   const adjustHeight = () => {
  //     const divEl = document.getElementById(
  //       "product-footer-picture-wrpr-id"
  //     ) as HTMLElement;
  //     if (divEl) {
  //       console.log("Set height for width ", divEl.offsetWidth);
  //       divEl.style.height = `${divEl.offsetWidth * 0.75}px`;
  //     }
  //   };
  //   if (isMobile) setTimeout(adjustHeight, 500);
  //   else setTimeout(adjustWidth, 500);
  // }, [props.images, widthObj.width, isMobile]);
  const history = useHistory();

  const getPhoneNumbers = (): string[] => {
    //console.log("Contact numbers ", props.phones);
    if (props.vypzeeMode) {
      return vypzeePhone;
    }
    if (!props.phones || !props.phones.length) return [];
    return props.phones;
    // let ret: string [] = [];
    // for (const phone of props.phones) {
    //   if (!phone) break;
    //   ret = ret + `${phone}, `;
    // }
    // console.log("Contact num ", ret);
    // return ret.slice(0, -2);
  };
  const phoneNumbers = getPhoneNumbers();
  const callButtonCss = `footer-call-whatsapp-button ${
    props.vcardMode
      ? "footer-call-whatsapp-button-vcard"
      : "footer-call-whatsapp-button-not-vcard"
  }`;
  const recordAction = useRecordUserInteractions();

  const PCLayoutJsx = (
    <div
      className={
        props.vcardMode ? "product-footer-vcard" : "product_footer_container"
      }
    >
      {!props.vcardMode && !!props.images?.length && (
        <div
          // className="product_footer_container_top"
          id="product-footer-picture-wrpr-id"
        >
          <div
            className="product_footer_container_top_left"
            id="product-footer-picture-id"
          >
            {!!props.images && (
              <ImageArraySlider
                imgFetchPerc="100"
                imageJsonArray={props.images}
                autoSlider={true}
                onClick={props.openImageArray}
                removeDisplay={true}
              />
            )}
            {props.vypzeeMode && (
              <img
                src={getLogo()}
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                  background: "var(--ion-color-light)",
                }}
                alt={props.name}
                loading="lazy"
              />
            )}
          </div>
          {/* <div className="product_footer_container_top_right">
          {props.name}
          <p>{props.tagline}</p>
        </div> */}
        </div>
      )}
      {props.vcardMode && (
        <IonGrid>
          <IonRow>
            {/* <IonCol size="4" className="product-footer-label">
              <IonAvatar>
                <IonImg src="assets/shop.png" />
              </IonAvatar>
            </IonCol> */}
            <IonCol size="12">
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderLeft: "5px solid var(--ion-color-secondary)",
                  marginTop: "5px",
                }}
              >
                <div style={{ paddingLeft: "10px" }}>{props.name}</div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      )}
      <div style={{ width: "100%", marginTop: "10px" }}>
        <IonGrid>
          <IonRow>
            <IonCol
              size="4"
              className="product-footer-label"
              onClick={() => {
                if (!props.verifyMode) return;
                props.updateChecklist("shopName", !props?.checkList?.shopName);
              }}
            >
              <div style={{ display: "flex" }}>
                <div style={{ width: "25px", flexShrink: "0" }}>
                  {!props.verifyMode && <IonIcon icon={personOutline} />}
                  {!!props.verifyMode && (
                    <IonIcon
                      icon={
                        props?.checkList?.shopDealsIn
                          ? checkmarkCircle
                          : ellipse
                      }
                      color={props?.checkList?.shopName ? "primary" : "medium"}
                    />
                  )}
                </div>
                <div>Name</div>
              </div>
            </IonCol>
            <IonCol size="8" className="product-footer-content">
              {!!props.vypzeeMode && <div>Vypzee - Local Markets Online</div>}
              {!props.vypzeeMode && <div>{props.name}</div>}
            </IonCol>
          </IonRow>
          {!!splittedDiscription && (
            <IonRow>
              <IonCol
                size="4"
                className="product-footer-label"
                onClick={() => {
                  if (!props.verifyMode) return;
                  props.updateChecklist(
                    "shopDealsIn",
                    !props?.checkList?.shopDealsIn
                  );
                }}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ width: "25px", flexShrink: "0" }}>
                    {!props.verifyMode && <IonIcon icon={briefcaseOutline} />}
                    {!!props.verifyMode && (
                      <IonIcon
                        icon={
                          props?.checkList?.shopDealsIn
                            ? checkmarkCircle
                            : ellipse
                        }
                        color={
                          props?.checkList?.shopDealsIn ? "primary" : "medium"
                        }
                      />
                    )}
                  </div>
                  <div>About</div>
                </div>
              </IonCol>
              <IonCol size="8" className="product-footer-content">
                {!!props.vypzeeMode && <div>{vypzeeAboutUs}</div>}
                <div>
                  {splittedDiscription?.split("\n").map((el, idx) => {
                    return <div key={idx}>{el}</div>;
                  })}
                </div>
                {!!hyperlink && (
                  <div>
                    <a href={hyperlink[0]}>{hyperlink[0]}</a>
                  </div>
                )}
                {!!hyperlink &&
                  !!hyperlink[1] &&
                  hyperlink[1]
                    .toString()
                    ?.split("\n")
                    .map((el, idx) => {
                      return <div key={idx}>{el}</div>;
                    })}
              </IonCol>
            </IonRow>
          )}
          {(!!phoneNumbers.length || !!props.vypzeeMode) && (
            <IonRow>
              <IonCol
                size="4"
                className="product-footer-label"
                onClick={() => {
                  if (!props.verifyMode) return;
                  props.updateChecklist(
                    "shopPhone",
                    !props?.checkList?.shopPhone
                  );
                }}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ width: "25px", flexShrink: "0" }}>
                    {!props.verifyMode && <IonIcon icon={callOutline} />}
                    {!!props.verifyMode && (
                      <IonIcon
                        icon={
                          props?.checkList?.shopPhone
                            ? checkmarkCircle
                            : ellipse
                        }
                        color={
                          props?.checkList?.shopPhone ? "primary" : "medium"
                        }
                      />
                    )}
                  </div>
                  <div>Phone</div>
                </div>
              </IonCol>
              <IonCol
                size="8"
                className="product-footer-content"
                style={{ paddingTop: "0" }}
              >
                {phoneNumbers.map((el, idx) => {
                  const isMob = isMobileNumber(el);
                  return (
                    <div
                      key={idx}
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "5px",
                        paddingLeft: "0",
                        paddingTop: "0",
                      }}
                    >
                      <div>{el}</div>
                      <div style={{ display: "flex" }}>
                        {isMob && (
                          <div
                            className={callButtonCss}
                            onClick={() => {
                              // const whatsappUrl = `https://api.whatsapp.com/send?phone=91${getValidWhatsAppPhone(
                              //   el
                              // )}`;
                              // window.open(whatsappUrl, "_system");
                              recordAction({
                                action: userActionsTable.whatsapp,
                                pageId: props.businessDetails.id,
                                pageSection: "FOOTER",
                                pageType: getPageType(
                                  props.businessDetails.isMarket,
                                  props.businessDetails.marketType
                                ),
                                notes: `${el}`,
                              });
                              whatsappMessage("", el);
                            }}
                          >
                            <IonIcon icon={logoWhatsapp} />
                          </div>
                        )}
                        <div
                          className={callButtonCss}
                          style={{ marginLeft: "10px" }}
                          onClick={() => {
                            recordAction({
                              action: userActionsTable.call,
                              pageId: props.businessDetails.id,
                              pageSection: "FOOTER",
                              pageType: getPageType(
                                props.businessDetails.isMarket,
                                props.businessDetails.marketType
                              ),
                              notes: `${el}`,
                            });
                            window.open(`tel:${el}`);
                          }}
                        >
                          <IonIcon icon={callSharp} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </IonCol>
            </IonRow>
          )}
          {(!!props.email || !!props.vypzeeMode) && (
            <IonRow>
              <IonCol size="4" className="product-footer-label">
                <div style={{ display: "flex" }}>
                  <div style={{ width: "25px", flexShrink: "0" }}>
                    <IonIcon icon={mailOutline} />
                  </div>
                  <div>Email</div>
                </div>
              </IonCol>
              <IonCol
                size="8"
                className="product-footer-content"
                style={{ paddingTop: "0" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "80%" }}>
                    {props.vypzeeMode ? vypzeeMail : props.email}
                  </div>
                  <div style={{ paddingRight: "5px" }}>
                    <div
                      className={callButtonCss}
                      onClick={async () => {
                        recordAction({
                          action: userActionsTable.email,
                          pageId: props.businessDetails.id,
                          pageSection: "FOOTER",
                          pageType: getPageType(
                            props.businessDetails.isMarket,
                            props.businessDetails.marketType
                          ),
                          notes: `${props.email}`,
                        });
                        await Clipboard.write({
                          string: props.vypzeeMode ? vypzeeMail : props.email,
                        });
                        presentStringToast("Link copied.");
                      }}
                    >
                      <IonIcon icon={copyOutline} />
                    </div>
                  </div>
                </div>
              </IonCol>
            </IonRow>
          )}
          {!!props.website && (
            <IonRow>
              <IonCol size="4" className="product-footer-label">
                <div style={{ display: "flex" }}>
                  <div style={{ width: "25px", flexShrink: "0" }}>
                    <IonIcon icon={globeOutline} />
                  </div>
                  <div>Website</div>
                </div>
              </IonCol>
              <IonCol
                size="8"
                className="product-footer-content"
                style={{ paddingTop: "0" }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "5px",
                    paddingLeft: "0",
                    paddingTop: "0",
                  }}
                >
                  <div>{props.website}</div>
                  <div
                    className={callButtonCss}
                    style={{ marginLeft: "10px" }}
                    onClick={() => {
                      recordAction({
                        action: userActionsTable.website,
                        pageId: props.businessDetails.id,
                        pageSection: "FOOTER",
                        pageType: getPageType(
                          props.businessDetails.isMarket,
                          props.businessDetails.marketType
                        ),
                        notes: `${props.website}`,
                      });
                      window.location.assign(props.website);
                    }}
                  >
                    <IonIcon icon={returnDownForward} />
                  </div>
                </div>
              </IonCol>
            </IonRow>
          )}
          {!!props.deliveryNotes && (
            <IonRow>
              <IonCol size="4" className="product-footer-label">
                <div style={{ display: "flex" }}>
                  <div style={{ width: "25px", flexShrink: "0" }}>
                    <IonIcon icon={bicycleOutline} />
                  </div>
                  <div>Delivery Notes</div>
                </div>
              </IonCol>
              <IonCol size="8" className="product-footer-content">
                {props.deliveryNotes}
              </IonCol>
            </IonRow>
          )}
          {(!!props.address || !!props.vypzeeMode) && (
            <IonRow>
              <IonCol
                size="4"
                className="product-footer-label"
                onClick={() => {
                  if (!props.verifyMode) return;
                  props.updateChecklist(
                    "shopAddress",
                    !props?.checkList?.shopAddress
                  );
                }}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ width: "25px", flexShrink: "0" }}>
                    {!props.verifyMode && <IonIcon icon={locationOutline} />}
                    {!!props.verifyMode && (
                      <IonIcon
                        icon={
                          props?.checkList?.shopAddress
                            ? checkmarkCircle
                            : ellipse
                        }
                        color={
                          props?.checkList?.shopAddress ? "primary" : "medium"
                        }
                      />
                    )}
                  </div>
                  <div>Address</div>
                </div>
              </IonCol>
              <IonCol size="8" className="product-footer-content">
                <div style={{ display: "flex" }}>
                  <div style={{ flexGrow: 1, paddingRight: "5px" }}>
                    {props.vypzeeMode
                      ? vypzeeAddresss
                      : props.address.split("\n").map((el, idx) => {
                          return <div key={idx}>{el}</div>;
                        })}
                  </div>
                  <div style={{ paddingRight: "5px" }}>
                    <div
                      className={callButtonCss}
                      onClick={() => {
                        props.directionExec();
                      }}
                    >
                      <IonIcon icon={navigate} />
                    </div>
                  </div>
                </div>
              </IonCol>
            </IonRow>
          )}
          {!!props.socialMedia && (
            <IonRow>
              <IonCol size="4" className="product-footer-label">
                <div style={{ display: "flex" }}>
                  <div style={{ width: "25px", flexShrink: "0" }}>
                    <IonIcon icon={appsOutline} />
                  </div>
                  <div>Social Media</div>
                </div>
              </IonCol>
              <IonCol size="8" className="product-footer-content">
                <div
                  style={{
                    display: "flex",
                    fontSize: "large",
                    color: "light",
                  }}
                >
                  {!!props.socialMedia.facebookLink && (
                    <>
                      <a
                        href={props.socialMedia.facebookLink}
                        style={{
                          color: "var(--ion-color-light)",
                        }}
                        onClick={() => {
                          recordAction({
                            action: userActionsTable.socialMedia,
                            pageId: props.businessDetails.id,
                            pageSection: "FOOTER",
                            pageType: getPageType(
                              props.businessDetails.isMarket,
                              props.businessDetails.marketType
                            ),
                            notes: `Facebook`,
                          });
                        }}
                      >
                        <IonIcon icon={logoFacebook} />
                      </a>
                      <div style={{ width: "10px" }}></div>
                    </>
                  )}
                  {!!props.socialMedia.instagramLink && (
                    <>
                      <a
                        href={props.socialMedia.instagramLink}
                        style={{ color: "var(--ion-color-light)" }}
                        onClick={() => {
                          recordAction({
                            action: userActionsTable.socialMedia,
                            pageId: props.businessDetails.id,
                            pageSection: "FOOTER",
                            pageType: getPageType(
                              props.businessDetails.isMarket,
                              props.businessDetails.marketType
                            ),
                            notes: `Instagram`,
                          });
                        }}
                      >
                        <IonIcon icon={logoInstagram} />
                      </a>
                      <div style={{ width: "10px" }}></div>
                    </>
                  )}
                  {!!props.socialMedia.youtubeLink && (
                    <>
                      <a
                        href={props.socialMedia.youtubeLink}
                        style={{ color: "var(--ion-color-light)" }}
                        onClick={() => {
                          recordAction({
                            action: userActionsTable.socialMedia,
                            pageId: props.businessDetails.id,
                            pageSection: "FOOTER",
                            pageType: getPageType(
                              props.businessDetails.isMarket,
                              props.businessDetails.marketType
                            ),
                            notes: `Youtube`,
                          });
                        }}
                      >
                        <IonIcon icon={logoYoutube} />
                      </a>
                      <div style={{ width: "10px" }}></div>
                    </>
                  )}
                  {!!props.socialMedia.linkedinLink && (
                    <>
                      <a
                        href={props.socialMedia.linkedinLink}
                        style={{ color: "var(--ion-color-light)" }}
                        onClick={() => {
                          recordAction({
                            action: userActionsTable.socialMedia,
                            pageId: props.businessDetails.id,
                            pageSection: "FOOTER",
                            pageType: getPageType(
                              props.businessDetails.isMarket,
                              props.businessDetails.marketType
                            ),
                            notes: `LinkedIn`,
                          });
                        }}
                      >
                        <IonIcon icon={logoLinkedin} color="light" />{" "}
                      </a>
                      <div style={{ width: "10px" }}></div>
                    </>
                  )}
                </div>
              </IonCol>
            </IonRow>
          )}
          {props.verifyMode && (
            <IonRow>
              <IonCol size="12">
                <div>
                  <IonButton
                    color={"light"}
                    onClick={() => {
                      history.push(
                        bhpEditLinks.shopProfile.replace(
                          "%storeId%",
                          `${props.businessDetails.id}`
                        )
                      );
                    }}
                  >
                    <IonIcon icon={pencil} slot="start" />
                    Edit Details
                  </IonButton>
                </div>
              </IonCol>
            </IonRow>
          )}
        </IonGrid>
        {props.vcardMode && !!props.vCardPromo && (
          <div>
            <Card title={"Promotion / Offer"}>{props.vCardPromo}</Card>
          </div>
        )}
        {/* {props.vcardMode && (
          <div style={{ margin: "10px", padding: "10px" }}>
            <IonButton
              expand="block"
              color={"dark"}
              onClick={() => {
                saveVcard(props.companyName, false, "", false, 0);
              }}
            >
              <IonIcon icon={download} slot="start" /> Download Digital Card
            </IonButton>
          </div>
        )} */}
      </div>

      {/* <div className="product_footer_container_icon-wrp">
        <div className="product_footer_container_bottom">
          <div>
            <div style={{ paddingBottom: "10px" }}>
              <b>
                <u>About us</u>
              </b>
            </div>
            <div>
              {splittedDiscription?.split("\n").map((el) => {
                return <div className="footer-text">{el}</div>;
              })}
            </div>
            {!!hyperlink && (
              <div style={{ fontSize: "1rem" }}>
                <a href={hyperlink[0]}>{hyperlink[0]}</a>
              </div>
            )}
            {!!hyperlink &&
              !!hyperlink[1] &&
              hyperlink[1]
                .toString()
                ?.split("\n")
                .map((el) => {
                  return <div className="footer-text">{el}</div>;
                })}

            {props.vypzeeMode &&
              vypzeeAboutUs.map((el) => {
                return (
                  <p style={{ fontWeight: 100, fontSize: "1rem" }}>{el}</p>
                );
              })}
          </div>

          <div style={{ paddingBottom: "5px", marginTop: "5px" }}>
            <b>
              <u>Contact us</u>
            </b>
          </div>

          {!!props.vypzeeMode && (
            <>
              <div className="product_footer_container_bottom_contact">
                {!!vypzeePhone && (
                  <div
                    style={{
                      display: "flex",
                      margin: "5px",
                      fontSize: "small",
                      justifyContent: "flex-end",
                    }}
                  >
                    <IonIcon icon={call} />

                    <div style={{ marginLeft: "5px" }}>{vypzeePhone}</div>
                  </div>
                )}
                {!!vypzeeMail && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                      margin: "5px",
                      fontSize: "small",
                    }}
                  >
                    <div style={{ marginRight: "10px" }}>
                      <IonIcon icon={mail} />
                    </div>
                    <div>{vypzeeMail}</div>
                  </div>
                )}
                {!!vypzeeAddresss && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                      margin: "5px",
                      fontSize: "small",
                    }}
                  >
                    <div style={{ marginRight: "10px" }}>
                      <IonIcon icon={location} />
                    </div>
                    <div>{vypzeeAddresss}</div>
                  </div>
                )}
              </div>
            </>
          )}

          <div className="product_footer_container_bottom_contact">
            {!!phoneNumbers && (
              <div
                style={{
                  display: "flex",
                  margin: "5px",
                  fontSize: "small",
                  justifyContent: "flex-end",
                }}
              >
                <IonIcon icon={call} />

                <div style={{ marginLeft: "5px" }}>{phoneNumbers}</div>
              </div>
            )}
            {!!props.email && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  margin: "5px",
                  fontSize: "small",
                }}
              >
                <div style={{ marginRight: "10px" }}>
                  <IonIcon icon={mail} />
                </div>
                <div>{props.email}</div>
              </div>
            )}
            {!!props.address && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  margin: "5px",
                  fontSize: "small",
                }}
              >
                <div style={{ marginRight: "10px" }}>
                  <IonIcon icon={location} />
                </div>
                <div>{props.address}</div>
              </div>
            )}
          </div>
        </div>

        {!!props.socialMedia && (
          <div className="social-media-icons">
            {!!props.socialMedia.facebookLink && (
              <a href={props.socialMedia.facebookLink}>
                <IonIcon icon={logoFacebook} />
              </a>
            )}
            {!!props.socialMedia.instagramLink && (
              <a href={props.socialMedia.instagramLink}>
                <IonIcon icon={logoInstagram} />
              </a>
            )}
            {!!props.socialMedia.youtubeLink && (
              <a href={props.socialMedia.youtubeLink}>
                <IonIcon icon={logoYoutube} />
              </a>
            )}
            {!!props.socialMedia.linkdenLink && (
              <a href={props.socialMedia.linkdenLink}>
                <IonIcon icon={logoLinkedin} />
              </a>
            )}
          </div>
        )}
      </div> */}
    </div>
  );
  return <div>{PCLayoutJsx}</div>;
};

export default ProductPageFooter;
